.kdx-footer {
    background: $footer_bg;
    
    .address-info {        
		font-style: normal;
        padding-bottom: 24px;
		margin-bottom: 29px;
		border-bottom: 1px solid rgba(#FFF, .18);

		p:last-of-type { padding: 0; }
    }
	.heading {
		@include text-size(23);
		@include line-height(26);
		font-weight: 700;
		color: $footerText;
		margin: 0 0 12px 0;				
	}
	.subheading {
		display: block;
		@include text-size(21);
		@include line-height(23);
		font-weight: 700;
		margin: 0 0 6px 0;
		color: $footerText;        
	}
    .brand {        
        margin: 0 0 35px;

		a { display: block; }
        img, svg {
            max-height: 53px;
        }
        h2 {
            @include text-size(29);
            font-weight: 400;
            margin: 0;
            padding: 0 0 0 $gutter-def;
        }

		a[href="/pfiedler-edu"]{
			img, svg{
				max-height: 107px;
			}
		}

		a[href="/surgical-expo"]{
			img, svg{
				max-height: 72px;
			}
		}

		a[href="/outpatient-surgery"]{
			img, svg{
				max-height: 86px;
			}
		}
    }
    .js-toggle-heading {
        position: relative;
        display: flex;
        flex: 1 0 auto;
        align-items: flex-end;
        color: $footerText;
        text-decoration: none;
        overflow: hidden;
		margin: 0 0 24px 0;
		pointer-events: none;
		border-bottom: 1px solid rgba($footer_dividerColor, .18);

		&.show { 
			border-bottom: 1px solid $footer_dividerColor;
			
			> h1, > h2, > h3, > h4, > h5, h6 {
                color: $footerText;
            }
		}
        > h1, > h2, > h3, > h4, > h5, h6 {
            width: 100%;
            @include text-size(21);
			@include line-height(27);
			font-weight: 700;
            color: $footerText;
			margin: 0;
			padding-bottom: 16px;
        }
		svg {
			@include svg-format(16px, 16px, currentColor);
			display: none;
		}
        

        &:hover, &:focus {
            text-decoration: none;
            color: $tertiary;

            > h1, > h2, > h3, > h4, > h5, h6 {
                color: $tertiary;
            }

            &:before, &:after {
                transform: translateX(100%);
                @include transitionDefault(transform);
            }
        }
    }
	.cta {
		.btn.btn-secondary {
			background-color: $footer_leftBtn_bg;
			border-color: $footer_leftBtn_bg;
			color: $footer_leftBtn_text;

			&:hover, &:focus {
				background-color: $footer_leftBtn_hover_bg;
				border-color: $footer_leftBtn_hover_bg;
				color: $footer_leftBtn_hover_text;
			}
		}
	}
    .link-list {
		display: flex;
		flex-wrap: wrap;
		align-items: flex-start;

		&.link-list-vertical { flex-direction: column; }
		&.link-list-cols {
			.link-item { 
				width: 50%;
				margin-bottom: 16px; 
			}
		}

        .link-item {            
            margin-bottom: 24px;
			padding-right: 16px;
			
			&:nth-child(odd) { margin-right: 0; }
            a {
                position: relative;
				@include text-size(15);
				@include line-height(21);
				font-weight: 600;
				font-family: $font-family-secondary;
                overflow: hidden;
                display: inline-flex;
				align-items: flex-start;
                background-color: transparent;
                color: $footerText;                
                border: none;
                border-radius: 0;
                text-decoration: none;				
                @include transitionDefault(all);

                &::after {
                    content: "";
                    position: absolute;
					display: inline-block;                    
                    background-color: currentColor;
                    height: 1px;
                    width: 100%;
                    bottom: 0px;
                    left: 0;
					opacity: 0;                    
                    transition: opacity .3s ease-in-out;
                }				
				svg {
					margin-left: 5px;
					@include svg-format(14px, 14px, currentColor);
					transition: transform .3s ease-in-out;
				}
                &:hover, &:focus {                    

					svg { transform: translateX(4px); }
                    &:after { opacity: 1; }
                }
            }           
        }
		&.quicklinks {
			.link-item {
				a {
					font-weight: 400;
					
					&::after {
						opacity: 1;
					}

					&:hover, &:focus {
						&::after { opacity: 0; }
					}
				}
			}
		}
    }
    .social-nav.social-links {
        padding: 60px 0 0 0;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		flex-wrap: wrap;

        a {
            display: flex;
			align-items: center;
			justify-content: center;
            position: relative;
            height: 39px;
            width: 39px;
			margin: 0 12px 16px 0;
            border-radius: 50%;
            border: solid 1px #FFF;
            background: #FFF;
			@include text-size(13);
			text-decoration: none;
			@include line-height(17);
			font-weight: 700;
			font-family: $font-family-secondary;            
            transition: transform .3s ease-in-out;

            svg {
				@include svg-format(20px, 20px, $primary);                
            }            
			&:last-child { margin-right: 0; }
            &:hover, &:focus {                
                background: #333936;
				border-color: #333936;
				color: #FFF;
                transform: translateY(-4px);                

                svg {
                    fill: #FFF;
                }
            }
        }
    }
	
    &-upper-tier {
        background: $primary;
        color: $footerText;
        padding: 35px 0;

        .footer-inline-items .kdx-inline-nav.download-links {
			text-align: center;
        }
    }
	
    &-lower-tier {
		padding: 24px 0;
        background: #FFF;
        color: #555;
				
		.copyright {
			@include text-size(14);
			@include line-height(20);
			font-family: $font-family-secondary;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-wrap: wrap;		
			
			a {
				color: $footer_copyright_links;
	
				&:hover, &:focus {
					color: #000;
					text-decoration: none;
				}
			}
			.copyright-links {
				margin-left: 8px;

				a {
					border-right: 1px solid #8E8E8E;
					padding-right: 8px;
					margin-right: 8px;

					&:last-child { border-right: none; }
				}
			}
		}        
    }    
}




@include media-breakpoint-down(lg) {
	.kdx-footer {
		text-align: center;

		.kdx-footer-upper-tier { padding: 32px 0 8px 0; }
		.brand { 
			justify-content: center; 
			margin-bottom: 24px;

			img, svg { max-height: 88px; }
		}		
		.subheading {
			@include text-size(18);
			@include line-height(21);
		}
		.address-info {
			margin-bottom: 16px;
			padding-bottom: 16px;
		}
		.address-info, .partner-info {
			@include text-size(13);
			@include line-height(21);			
		}
		.footer-link-items {
			margin-top: 32px;
		}
		.js-toggle-heading {
			text-align: left;
			pointer-events: all;
			display: flex;
			justify-content: space-between;
			align-items: center;

			&:hover, &:focus { 
				color: #FFF; 

				h3 { color: #FFF; }
			}
			svg { display: inline-block; }			
		}
		.link-list {
			display: none;			

			&.show { display: flex; }
			.link-item {
				text-align: left;

				a { display: inline-flex; }
			}
		}
		.social-nav.social-links {
			justify-content: center;
			padding: 8px 24px;

			a {
				margin: 8px;

				&:last-child { margin-right: 8px; }
			}
		}
	}
}




@include media-breakpoint-down(sm) {
	.kdx-footer {

		.partner-info {
			.btn { 
				width: 90%;
				margin: 0 auto;
			}
		}
	}
}